import { Button, Space } from 'antd';
import React, { useState } from 'react';
import styled from 'styled-components';
import { CollectFilled } from '@assets';
import { useNavigate } from 'react-router-dom';
import { PRIVATE_ROUTE } from '@router/route.constants';
import { api } from '@api';
import { useDispatch } from 'react-redux';
import { openAlert } from "@redux/app/appSlice";
import { Alert } from '@components';
import { useTranslation } from 'react-i18next';

const Card = styled.div`
margin-top: ${props => props.mode === 'home' ? '10px' : '0'};
margin-bottom: ${props => props.mode === 'home' ? '12px' : '6px'};
padding: 12px;
display: flex;
align-items: flex-start;
gap: 12px;
border-radius: 16px;
background: #fff;
box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.10);

svg {
    min-width: 44px;
    height: 44px;
}

@media screen and (max-width: 325px) {
    padding: 6px 4px;
    gap: 4px;
}
`;

const Content = styled.div`
flex: 1;
display: flex;
flex-direction: column;
gap: 4px;
align-items: flex-start;
justify-content: center;
overflow: hidden;
position: relative;

.ant-space {
    gap: 0 !important;
    align-items: flex-end;
}
`;

const Title = styled.div`
font-size: 14px;
font-weight: 700;
color: #1C1C1C;
line-height: 1.5;

@media screen and (max-width: 325px) {
    font-size: 12px;
}
`;

const Text = styled.div`
font-size: 12px;
font-weight: 400;
color: #4F4F4F;
line-height: 2;
cursor: pointer;

width: 100%;
overflow: hidden;
display: ${props => props.showAll === 'true' ? "block" : "-webkit-box"};
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* start showing ellipsis when 2nd line is reached */
  white-space: pre-wrap; /* let the text wrap preserving spaces */

  @media screen and (max-width: 325px) {
    font-size: 11px;
}
`;

const ActionButton = styled(Button).attrs({
    type: 'primary',
})`
padding: 4px 12px !important;
width: auto !important;
height: 36px !important;
font-size: 12px !important;
font-weight: 700 !important;
line-height: 1.5 !important;

@media screen and (max-width: 325px) {
    font-size: 11px !important;
}

:disabled {
    background: #DEDEDE !important;
    color: #ABABAB !important;
}
`;

const MoreButton = styled(Button).attrs({
    type: 'ghost',
})`
position: absolute;
top: 0;
right: 0;

padding: 4px 6px !important;
min-width: 24px !important;
width: auto !important;
height: 24px !important;
font-size: 10px !important;
font-weight: 700 !important;
line-height: 1.5 !important;
border-radius: 50% !important;
background: #FEBF15 !important;

span {
color: #fff !important;
}

@media screen and (max-width: 325px) {
    font-size: 9px !important;
}
`;

const CollectCard = ({
    item,
    moreCount = 0,
    mode = 'list',
    successCallback,
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [isMoreClicked, setIsMoreClicked] = useState(false);

    const collect = () => {
        if (!loading) {
            setLoading(true);
            api
                .thawBalance({
                    freeze_balance_id: item.freeze_balance_id,
                })
                .then(() => {
                    setLoading(false);
                    showAlert({
                        message: t("freezeBalance.successMessage"),
                        successCallback: () => successCallback(item.freeze_balance_id),
                    });
                })
                .catch((error) => {
                    setLoading(false);
                    showAlert({
                        message: error.message || error,
                        isError: true,
                    });
                });
        }
    }

    const showAlert = (data) => {
        dispatch(openAlert(data));
    };

    const seeMore = () => {
        navigate(`/${PRIVATE_ROUTE.FREEZE_BALANCES}`);
    }

    return (
        <>
            <Card mode={mode}>
                <CollectFilled />
                <Content>
                    {moreCount > 0 &&
                        <MoreButton onClick={seeMore}>
                            {`+${moreCount}`}
                        </MoreButton>
                    }
                    <Title>{t("freezeBalance.title")}</Title>
                    <Space>
                        <Text
                            showAll={isMoreClicked ? "true" : "false"}
                            onClick={() => setIsMoreClicked(prev => !prev)}
                        >
                            {t("freezeBalance.message", {
                                game_name: item.name_en
                            })}
                        </Text>
                    </Space>
                    <ActionButton
                        disabled={loading}
                        onClick={collect}
                    >
                        {t("freezeBalance.collect")}
                    </ActionButton>
                </Content>
            </Card>
            <Alert />
        </>
    );
}

export default CollectCard;